// @ts-nocheck
import * as Types from "../../../../types/types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type QueryAdvisorBlankSlateQueryVariables = Types.Exact<{
  serverId: Types.Scalars["ID"]["input"];
}>;

export type QueryAdvisorBlankSlateQuery = {
  __typename?: "GraphqlQuery";
  getServerDetails: {
    __typename?: "Server";
    id: string;
    integratedLogInsights: boolean;
    integratedExplain: boolean;
    systemType?: string | null;
  };
  autoExplainMinDuration?: {
    __typename?: "PostgresSetting";
    id: string;
    value?: string | null;
  } | null;
  autoExplainAnalyze?: {
    __typename?: "PostgresSetting";
    id: string;
    value?: string | null;
  } | null;
  autoExplainFormat?: {
    __typename?: "PostgresSetting";
    id: string;
    value?: string | null;
  } | null;
  sharedPreloadLibraries?: {
    __typename?: "PostgresSetting";
    id: string;
    value?: string | null;
  } | null;
  sessionPreloadLibraries?: {
    __typename?: "PostgresSetting";
    id: string;
    value?: string | null;
  } | null;
  logLinePrefix?: {
    __typename?: "PostgresSetting";
    id: string;
    value?: string | null;
  } | null;
};

export const QueryAdvisorBlankSlateDocument = gql`
  query QueryAdvisorBlankSlate($serverId: ID!) {
    getServerDetails(serverId: $serverId) {
      id
      integratedLogInsights
      integratedExplain
      systemType
    }
    autoExplainMinDuration: getPostgresSettingDetails(
      serverId: $serverId
      postgresSettingName: "auto_explain.log_min_duration"
    ) {
      id
      value: resetValuePrettyNoDelimiter
    }
    autoExplainAnalyze: getPostgresSettingDetails(
      serverId: $serverId
      postgresSettingName: "auto_explain.log_analyze"
    ) {
      id
      value: resetValuePrettyNoDelimiter
    }
    autoExplainFormat: getPostgresSettingDetails(
      serverId: $serverId
      postgresSettingName: "auto_explain.log_format"
    ) {
      id
      value: resetValuePrettyNoDelimiter
    }
    sharedPreloadLibraries: getPostgresSettingDetails(
      serverId: $serverId
      postgresSettingName: "shared_preload_libraries"
    ) {
      id
      value: resetValuePrettyNoDelimiter
    }
    sessionPreloadLibraries: getPostgresSettingDetails(
      serverId: $serverId
      postgresSettingName: "session_preload_libraries"
    ) {
      id
      value: resetValuePrettyNoDelimiter
    }
    logLinePrefix: getPostgresSettingDetails(
      serverId: $serverId
      postgresSettingName: "log_line_prefix"
    ) {
      id
      value: resetValuePrettyNoDelimiter
    }
  }
`;

/**
 * __useQueryAdvisorBlankSlateQuery__
 *
 * To run a query within a React component, call `useQueryAdvisorBlankSlateQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryAdvisorBlankSlateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryAdvisorBlankSlateQuery({
 *   variables: {
 *      serverId: // value for 'serverId'
 *   },
 * });
 */
export function useQueryAdvisorBlankSlateQuery(
  baseOptions: Apollo.QueryHookOptions<
    QueryAdvisorBlankSlateQuery,
    QueryAdvisorBlankSlateQueryVariables
  > &
    (
      | { variables: QueryAdvisorBlankSlateQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    QueryAdvisorBlankSlateQuery,
    QueryAdvisorBlankSlateQueryVariables
  >(QueryAdvisorBlankSlateDocument, options);
}
export function useQueryAdvisorBlankSlateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    QueryAdvisorBlankSlateQuery,
    QueryAdvisorBlankSlateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    QueryAdvisorBlankSlateQuery,
    QueryAdvisorBlankSlateQueryVariables
  >(QueryAdvisorBlankSlateDocument, options);
}
// @ts-ignore
export function useQueryAdvisorBlankSlateSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    QueryAdvisorBlankSlateQuery,
    QueryAdvisorBlankSlateQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  QueryAdvisorBlankSlateQuery,
  QueryAdvisorBlankSlateQueryVariables
>;
export function useQueryAdvisorBlankSlateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QueryAdvisorBlankSlateQuery,
        QueryAdvisorBlankSlateQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  QueryAdvisorBlankSlateQuery | undefined,
  QueryAdvisorBlankSlateQueryVariables
>;
export function useQueryAdvisorBlankSlateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        QueryAdvisorBlankSlateQuery,
        QueryAdvisorBlankSlateQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    QueryAdvisorBlankSlateQuery,
    QueryAdvisorBlankSlateQueryVariables
  >(QueryAdvisorBlankSlateDocument, options);
}
export type QueryAdvisorBlankSlateQueryHookResult = ReturnType<
  typeof useQueryAdvisorBlankSlateQuery
>;
export type QueryAdvisorBlankSlateLazyQueryHookResult = ReturnType<
  typeof useQueryAdvisorBlankSlateLazyQuery
>;
export type QueryAdvisorBlankSlateSuspenseQueryHookResult = ReturnType<
  typeof useQueryAdvisorBlankSlateSuspenseQuery
>;
export type QueryAdvisorBlankSlateQueryResult = Apollo.QueryResult<
  QueryAdvisorBlankSlateQuery,
  QueryAdvisorBlankSlateQueryVariables
>;
